var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex select-root"},_vm._l((_vm.options),function(o,i){return _c('button',{staticClass:"select-item flex-fill",class:{
		active:o.value === _vm.value,
	},on:{"click":function($event){return _vm.$emit('input', o.value)}}},[_vm._v(" "+_vm._s(o.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }